module.exports = __webpack_public_path__ + "img/hmp-logo-blanco.ca97afe7.png";